import axios from "axios";
import { getToken, deleteToken, isTokenExpired } from "../utils/token";

const api = axios.create({
  baseURL: process.env.REACT_APP_ENV === "development"
    ? process.env.REACT_APP_DEV_API_URL
    : process.env.REACT_APP_API_BASE_URL,
  withCredentials: true, // needed if refresh token is in HttpOnly cookie
});

const publicRoutePatterns = [
  /login/i,
  /register/i,
  /newsletter/i,
  /subscribe/i,
  /event/i,
];

const isPublicRequest = (url = "") =>
  publicRoutePatterns.some((pattern) => pattern.test(url));

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const requestUrl = config?.url || "";
    const skipAuth = config?.skipAuth === true || isPublicRequest(requestUrl);

    if (skipAuth) {
      return config;
    }

    let token = getToken();
    const expired = token ? isTokenExpired(token) : true;

    if (token && expired) {
      deleteToken();
      token = null;
    }

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || "";

    if (status === 401 && !isPublicRequest(requestUrl)) {
      deleteToken();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;